import StarterKit from "./StarterKit";

import Header from "./components/Header";
import NavsFull from "./components/NavsFull";

import BlockBanner from "./blocks/BlockBanner";
import BlockMovie from "./blocks/BlockMovie";
import BlockSeparator from "./blocks/BlockSeparator";

import Share from "./components/Share";
import BlockAnchor from "./blocks/BlockAnchor";
import BlockDataSlider from "./blocks/BlockDataSlider";
import BlockScrollingText1Image from "./blocks/BlockScrollingText1Image";
import BlockMarkets from "./blocks/BlockMarkets";
import Search from "./components/Search";
import BlockPartsHover from "./blocks/BlockPartsHover";
import BlockPartIndustries from "./blocks/BlockPartIndustries";
import Collapse from "./components/Collapse";
import FormFileUpload from "./components/FormFileUpload";
import BlockBannerHome from "./blocks/BlockBannerHome";
import BlockServiceAdditional from "./blocks/BlockServiceAdditional";
import MarketPartModal from "./components/MarketPartModal";
import FollowCursor from "./components/FollowCursor";

window.initMap = function(){
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	Collapse.init();
	FollowCursor.init();
	FormFileUpload.init();
	Header.init();
	MarketPartModal.init();
	NavsFull.init();
	Search.init();

	// Blocks
	BlockAnchor.init();
	BlockBanner.init();
	BlockBannerHome.init();
	BlockDataSlider.init();
	BlockMarkets.init();
	BlockMovie.init();
	BlockPartIndustries.init();
	BlockPartsHover.init();
	BlockScrollingText1Image.init();
	BlockSeparator.init();
	BlockServiceAdditional.init();

	Share.init();
});
